// Types
export interface Content {
  id: number;
  name: string;
}

interface ContentState {
  loading: boolean;
  content_data: Content[];
  error: string | null;
}

const initialState: ContentState = {
  loading: false,
  content_data: [],
  error: null,
};

type Action =
  | { type: 'CONTENT_LOADING' }
  | { type: 'CONTENT_SUCCESS'; payload: Content[] }
  | { type: 'CONTENT_ERROR'; payload: string };

 export const ContentReducer = (state = initialState, action: Action): ContentState => {
  switch (action.type) {
    case 'CONTENT_LOADING':
      return { ...state, loading: true };
    case 'CONTENT_SUCCESS':
      return { loading: false, content_data: action.payload, error: null };
    case 'CONTENT_ERROR':
      return { loading: false, content_data: [], error: action.payload };
    default:
      return state;
  }
};


// export interface ContentDetail {
//   id: number;
//   slug:string;
//   title: string;
// }

interface ContentDetailState {
  loading: boolean;
  content_data: {},
  error: string | null;
}

const initialDetailsState: ContentDetailState = {
  loading: false,
  content_data: {},
  error: null,
};


export const ContentDtailsReducer = (state = initialDetailsState, action: Action): ContentDetailState => {
  switch (action.type) {
    case 'CONTENT_LOADING':
      return { ...state, loading: true };
    case 'CONTENT_SUCCESS':
      return { loading: false, content_data: action.payload, error: null };
    case 'CONTENT_ERROR':
      return { loading: false, content_data: [], error: action.payload };
    default:
      return state;
  }
};

